import {useState} from "react";
import {useSearchParams} from "react-router-dom";
import useEditFeatureFlag from "../../Hooks/FeatureFlags/useEditFeatureFlag";
import {Types, typeText} from "../../Constants/FeatureFlags/types";
import {SearchParams} from "../../Constants/FeatureFlags/searchParams";
import {Button} from "../Fundamentals/Button";
import {useTranslation} from "react-i18next";

function FeatureFlagTable ({label, flags, deleteFeatureFlag, deleteButtonOption}) {
    const { t } = useTranslation();
    const [sortKey, setSortKey] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams()
    const { externalClients, managedTeams, users } = useEditFeatureFlag();

    const sortFlags = (flags, key) => {
        if (!key) return flags;

        const sorted = [...flags]
        if (key === 'userId') {
            sorted.sort((a, b) => {
                let avalue = a[key], bvalue = b[key]
                if (a.userType === Types.User)
                    avalue = getFlagUser(a)
                if (b.userType === Types.User)
                    bvalue = getFlagUser(b)
                if (a.userType === Types.Team)
                    avalue = managedTeams.find(t => t.id === a[key])?.name
                if (b.userType === Types.Team)
                    bvalue = managedTeams.find(t => t.id === b[key])?.name
                if (a.userType === Types.Api)
                    avalue = externalClients.find(t => t.id === a[key])?.name
                if (b.userType === Types.Api)
                    bvalue = externalClients.find(t => t.id === b[key])?.name
                if (avalue < bvalue) return -1;
                if (avalue > bvalue) return 1;
                return 0;
            })
        } else
            sorted.sort((a, b) => {
                if (a[key] < b[key]) return -1;
                if (a[key] > b[key]) return 1;
                return 0;
            })

        return sorted;
    }
    const selectUser = (flag) => {
        searchParams.set(SearchParams.Id, flag.userId);
        searchParams.set(SearchParams.Type, flag.userType);
        setSearchParams(searchParams);
    }
    const nonExistent = (id) => {
        return <div className="text-error">{`Non-existent (id): ${id}`}</div>
    }
    const getFlagUser = (flag) => {
        if (flag.userType === Types.User)
            return users?.find(u => u.id === flag.userId)?.name || nonExistent(flag.userId);
        if (flag.userType === Types.Team)
            return managedTeams?.find(t => t.id === flag.userId)?.name || nonExistent(flag.userId);
        if (flag.userType === Types.Api)
            return externalClients?.find(t => t.id === flag.userId)?.name || nonExistent(flag.userId);
    }

    const sortedFlags = sortFlags(flags, sortKey);
    return <div className="table">
        <table className="table table-hover">
            {label && <caption className="bold">{label}</caption>}
            <thead>
            <tr>
                <th onClick={() => setSortKey('name')}>{t('featureflagscontainer.flag')}</th>
                <th onClick={() => setSortKey('userType')}>{t('featureflagscontainer.targettype')}</th>
                <th onClick={() => setSortKey('userId')}>{t('featureflagscontainer.target')}</th>
                <th onClick={() => setSortKey('teamName')}>{t('featureflagscontainer.team')}</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            {sortedFlags?.map(flag => {
                return <tr key={flag.id} onClick={() => selectUser(flag)}>
                    <td>{flag.name}</td>
                    <td>{typeText[flag.userType]}</td>
                    <td>{getFlagUser(flag) ?? ''}</td>
                    <td>{flag.teamName ?? ''}</td>
                    <td>
                        <Button option={deleteButtonOption}
                                onClick={e => deleteFeatureFlag(e, flag.id)}>{t('common.delete')}
                        </Button>
                    </td>
                </tr>
            })
            }
            </tbody>
        </table>
    </div>
}

export default FeatureFlagTable;